import React from 'react';

import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import AuthSuccess from '../../components/authSuccess/AuthSuccess';

const messages = {
  invitation: {
    message: `
      Your password has been successfully created. 
      You will redirected to your page automatically. 
      If it take so long, please click on the button below to log in to your account.
    `,
    title: 'Password Created',
  },
  register: {
    message: 'Your account has been created. Please log in using the credentials provided. ',
    title: 'Successful Registration',
  },
  reset: {
    message: 'Your password has been reset. Please click on the button below to log in to your account. ',
    title: 'Password Reset',
  },
};
export default () => {
  const history = useHistory();
  const onLogin = () => history.push('/login');
  const { search } = useLocation();
  let { action } = queryString.parse(search);
  action = action && messages[action] ? action : 'register';

  if (action === 'register') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: {
        title: 'Register Success',
        url: '/auth-success?action=register',
      },
    });
    console.log(window.dataLayer);
  }

  return <AuthSuccess onLogin={onLogin} messages={messages[action]} />;
};
